var _path, _ellipse, _path2, _path3, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path4, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfettiMini = function SvgConfettiMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 44,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.854 38.18 17.56 14.904l1.244 2.37a19 19 0 0 0 8.08 8.032l2.383 1.237L5.854 38.18Z",
    fill: "#FFDC40"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.254,
    cy: 1.834,
    rx: 8.254,
    ry: 1.834,
    transform: "scale(1.00292 .99707) rotate(45 -7.073 29.527)",
    fill: "#FF9400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.66 21.374c.134.24.44.326.682.192a.497.497 0 0 0 .193-.678l-.876.486Zm-5.846-2.356.111.486-.111-.486Zm-7.64 3.454.224.447-.223-.447Zm14.36-1.584c-.67-1.192-2.076-1.843-3.376-2.167-1.312-.327-2.683-.364-3.455-.19l.222.973c.574-.13 1.779-.118 2.989.184 1.222.305 2.283.863 2.745 1.686l.876-.486Zm-6.831-2.356c-.53.12-.891.418-1.16.775-.252.336-.44.75-.612 1.11-.36.752-.732 1.446-1.617 1.865l.432.9c1.226-.58 1.723-1.568 2.09-2.336.192-.4.333-.705.51-.942.163-.216.335-.345.58-.4l-.223-.972Zm-3.389 3.75c-.453.215-.803.256-1.093.23-.302-.03-.574-.134-.882-.272-.58-.26-1.376-.714-2.387-.214l.446.893c.514-.254.84-.079 1.529.23.326.146.724.31 1.2.355.485.045 1.016-.036 1.619-.322l-.432-.9Zm-4.362-.256c-.62.307-1.34.796-1.888 1.196a27.076 27.076 0 0 0-.96.733l-.005.003-.001.001.317.386.317.387v-.001c.002 0 .003-.002.004-.003l.013-.01.05-.04c.045-.036.11-.088.193-.152.165-.128.397-.305.664-.5.541-.393 1.203-.84 1.742-1.107l-.446-.893Z",
    fill: "#2097F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 2.989a.503.503 0 0 1 .692-.154.497.497 0 0 1 .155.688l-.847-.534Zm.85 6.846.443.233-.444-.233Zm-5.334 6.442-.376-.33.376.33Zm5.331-12.755c-.52.817-.702 1.507-.716 2.093-.013.59.144 1.113.36 1.598.11.245.232.475.355.703.119.22.246.45.347.666.19.408.382.954.1 1.486l-.887-.465c.04-.075.058-.214-.123-.6-.085-.183-.193-.379-.32-.615-.125-.23-.263-.49-.388-.77-.252-.566-.464-1.24-.446-2.025.017-.79.265-1.654.871-2.604l.847.534Zm.446 6.546c-.253.478-.637.747-1.053.913-.392.155-.843.229-1.237.3-.824.152-1.594.33-2.23 1.07l-.763-.646c.881-1.028 1.97-1.25 2.81-1.404.44-.08.771-.136 1.048-.246.252-.1.421-.232.538-.452l.887.465Zm-4.52 2.284c-.326.38-.457.705-.506.99-.05.297-.019.586.035.918.103.624.338 1.505-.41 2.347l-.752-.66c.38-.427.294-.786.172-1.527-.057-.35-.113-.776-.034-1.244.082-.478.299-.967.732-1.471l.763.647Zm-.88 4.255c-.46.518-1.128 1.079-1.662 1.499a26.587 26.587 0 0 1-.897.674l-.057.04-.015.012-.004.003h-.001l-.29-.407-.289-.407h.001l.003-.003.014-.01a13.329 13.329 0 0 0 .251-.181c.169-.124.402-.299.662-.503.526-.414 1.134-.93 1.531-1.377l.752.66Z",
    fill: "#57E3A4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 0.917,
    cy: 0.917,
    r: 0.917,
    transform: "scale(1.00292 .99707) rotate(45 4.319 30.353)",
    fill: "red"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.917,
    cy: 0.917,
    r: 0.917,
    transform: "scale(1.00292 .99707) rotate(45 -3.89 28.25)",
    fill: "#2097F6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.917,
    cy: 0.917,
    r: 0.917,
    transform: "scale(1.00292 .99707) rotate(45 -3.13 38.941)",
    fill: "red"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.917,
    cy: 0.917,
    r: 0.917,
    transform: "scale(1.00292 .99707) rotate(45 -.156 50.55)",
    fill: "#FFD80C"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.917,
    cy: 0.917,
    r: 0.917,
    transform: "scale(1.00292 .99707) rotate(45 -6.228 55.816)",
    fill: "#57E3A4"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.917,
    cy: 0.917,
    r: 0.917,
    transform: "scale(1.00292 .99707) rotate(45 7.102 39.289)",
    fill: "#2097F6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.917,
    cy: 0.917,
    r: 0.917,
    transform: "scale(1.00292 .99707) rotate(45 -6.34 46.69)",
    fill: "#2097F6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.917,
    cy: 0.917,
    r: 0.917,
    transform: "scale(1.00292 .99707) rotate(45 5.19 50.17)",
    fill: "#57E3A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.168 8.9a.5.5 0 1 0-.13-.988l.13.989Zm-4.943 1.77-.425-.264.425.263Zm0 5.172.413.283-.413-.283Zm-5.528 1.617-.33-.375.33.375Zm-2.276 4.203-.144-.478.144.478ZM37.103 8.406a89.935 89.935 0 0 0-.065-.494h-.004l-.01.002a4.954 4.954 0 0 0-.164.024 13.747 13.747 0 0 0-1.932.459 8.805 8.805 0 0 0-1.725.74c-.547.317-1.067.73-1.403 1.27l.851.525c.218-.348.587-.661 1.058-.934a7.808 7.808 0 0 1 1.525-.651 12.733 12.733 0 0 1 1.927-.445l.006-.001h.001l-.065-.495Zm-5.303 2c-.678 1.083-.286 2.194-.022 3.02.29.91.453 1.53.035 2.133l.825.566c.736-1.06.362-2.168.096-3-.293-.916-.478-1.56-.083-2.193l-.851-.526Zm.013 5.153c-.473.681-1.16.741-2.191.73-.954-.01-2.237-.092-3.255.795l.66.75c.675-.588 1.517-.558 2.584-.547.99.01 2.222-.002 3.027-1.162l-.825-.566Zm-5.446 1.525c-.862.75-1 1.877-1.155 2.637-.084.416-.168.736-.31.982a.997.997 0 0 1-.625.481l.288.955c.58-.173.958-.512 1.205-.938.233-.401.341-.868.425-1.283.182-.9.284-1.607.832-2.084l-.66-.75Zm-2.09 4.1c-.273.081-.684.088-1.071.062a7.266 7.266 0 0 1-.647-.075h-.001l-.088.49-.089.491h.002l.004.001.012.003a4.135 4.135 0 0 0 .205.03c.134.018.321.04.533.055.406.027.97.035 1.428-.102l-.288-.955Z",
    fill: "red"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.477,
    cy: 42.522,
    rx: 11.957,
    ry: 1.372,
    fill: "#D6D7F5"
  })));
};
export default SvgConfettiMini;